import script from "./UserServiceDialogue.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserServiceDialogue.vue?vue&type=script&setup=true&lang=ts"

import "./UserServiceDialogue.vue?vue&type=style&index=0&id=799dddeb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-799dddeb"]])

export default __exports__